import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Sidebar from "../shared/Sidebar";

function Certifications() {
  
 const baseUrl = process.env.baseUrl;
  const [formData, setFormData] = useState({
    isoCertified: "",
    benchmarkCertifications: "",
    wastewaterReuse: "",
    wasteToEnergy: "",
  });

  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const validate = () => {
    let newErrors = {};
    if (!formData.isoCertified.trim()) newErrors.isoCertified = "This field is required";
    if (!formData.benchmarkCertifications.trim()) newErrors.benchmarkCertifications = "This field is required";
    if (!formData.wastewaterReuse.trim()) newErrors.wastewaterReuse = "This field is required";
    if (!formData.wasteToEnergy.trim()) newErrors.wasteToEnergy = "This field is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      await axios.post(`${baseUrl}/api/data-entry/certifications`, formData); // replace with your API endpoint
      navigate("/documentsupload"); // navigate on success
    } catch (err) {
      console.error("Submission failed:", err);
      alert("Failed to submit data. Please try again.");
    }
  };

  return (
    <div className="container col-lg-9 mt-5">
      <div className="row">
        <div className="col-md-4">
          <Sidebar />
        </div>

        <div className="col-md-8">
          <div className="form-section">
            <h5 className="mb-4">Certifications & Compliance</h5>
            <form onSubmit={handleSubmit}>
              <div className="row mb-3">
                <div className="col-md-12 mb-3">
                  <input
                    type="text"
                    name="isoCertified"
                    value={formData.isoCertified}
                    onChange={handleChange}
                    className={`form-control ${errors.isoCertified ? "is-invalid" : ""}`}
                    placeholder="ISO 50001:2018 Certified?"
                  />
                  {errors.isoCertified && (
                    <div className="invalid-feedback">{errors.isoCertified}</div>
                  )}
                </div>

                <div className="col-md-12 mb-3">
                  <input
                    type="text"
                    name="benchmarkCertifications"
                    value={formData.benchmarkCertifications}
                    onChange={handleChange}
                    className={`form-control ${errors.benchmarkCertifications ? "is-invalid" : ""}`}
                    placeholder="International Benchmark Certifications?"
                  />
                  {errors.benchmarkCertifications && (
                    <div className="invalid-feedback">{errors.benchmarkCertifications}</div>
                  )}
                </div>

                <div className="col-md-12 mb-3">
                  <input
                    type="text"
                    name="wastewaterReuse"
                    value={formData.wastewaterReuse}
                    onChange={handleChange}
                    className={`form-control ${errors.wastewaterReuse ? "is-invalid" : ""}`}
                    placeholder="Treated Wastewater Reuse"
                  />
                  {errors.wastewaterReuse && (
                    <div className="invalid-feedback">{errors.wastewaterReuse}</div>
                  )}
                </div>

                <div className="col-md-12 mb-3">
                  <input
                    type="text"
                    name="wasteToEnergy"
                    value={formData.wasteToEnergy}
                    onChange={handleChange}
                    className={`form-control ${errors.wasteToEnergy ? "is-invalid" : ""}`}
                    placeholder="Waste Used for Energy or Production?"
                  />
                  {errors.wasteToEnergy && (
                    <div className="invalid-feedback">{errors.wasteToEnergy}</div>
                  )}
                </div>
              </div>

              <button type="submit" className="btn btn-custom w-100">
                Continue →
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Certifications;
